module.exports = __webpack_public_path__ + "img/pr-2.cee56233.png";